if (!customElements.get('quote-icon-bubble')) {
  class QuoteIconBubble extends HTMLElement {
    constructor() {
      super();

      // get elements
      this.quoteCount = this.querySelector('[data-quote-count]');

      // event listeners
      document.addEventListener('quote-added', this.updateCount.bind(this));

      // join/create the quote broadcast channel
      this.quoteChannel = new BroadcastChannel('quote-channel');

      // init quote count
      this.updateCount();

      // listen for quote channel messages, then update the count in other tabs
      this.quoteChannel.onmessage = () => {
        this.updateCount();
      };
    }

    updateCount() {
      this.quoteItems = parseJson(localStorage.getItem('quote_cart')) || [];
      let quoteCount = 0;
      this.quoteItems.forEach((quoteItem) => {
        quoteCount += quoteItem.quantity;
      });

      if (quoteCount === 0) {
        this.quoteCount.querySelector('[data-quote-count-value]').textContent = '';
        this.quoteCount.classList.add('empty');

        this.quoteCount.querySelector('[data-quote-count-sr]').textContent =
          window.quoteStrings.countZero;
      } else if (quoteCount > 0) {
        this.quoteCount.querySelector('[data-quote-count-value]').textContent = quoteCount;
        this.quoteCount.classList.remove('empty');

        quoteCount === 1
          ? (this.quoteCount.querySelector('[data-quote-count-sr]').textContent =
              window.quoteStrings.countOne)
          : (this.quoteCount.querySelector('[data-quote-count-sr]').textContent =
              window.quoteStrings.countOther.replace('[count]', quoteCount));
      }
    }
  }

  window.QuoteIconBubble = QuoteIconBubble;
  customElements.define('quote-icon-bubble', QuoteIconBubble);
}
